<div class="d-flex flex-row align-items-center mt-4 gap-8">

  <div class="pointer id_box br-6 d-flex justify-content-center align-items-center" (click)="goToDocument(document)" title="Ouvrir le document dans un nouvel onglet">
    <span class="material-icons txt-yellow-happy">account_box</span>
  </div>

  <div class="d-flex flex-column w-100">
    <div class="fw-bold font-16">{{ document.name }}</div>

    <div class="d-flex align-items-center">
      <span class="font-14 fw-light mediumGray">X.X Mb</span>
      <mat-icon class="download-icon font-16 mediumGray d-flex align-items-center justify-content-center pointer" title="Télécharger" (click)="downloadFile()">open_in_browser</mat-icon>
      <button class="font-12 fw-light txt-blue-sky border-0 btn py-1 px-2" (click)="showReupload()">Uploader le document</button>
    </div>
  </div>

    <div class="d-flex flex-row gap-8 ms-auto">
      <button class="btn py-1 font-12 fw-light border-grey border-2 rounded-0" title="Valider le document" [ngClass]="{'btn-success border-success': document.pivot.state == 'validated'}" (click)="validate('validated')">Valider</button>
      <button class="btn py-1 font-12 fw-light border-grey border-2 rounded-0" title="Définir un motif de refus"
              [ngClass]="{'border-primary': openRefusalPopUp, 'btn-danger border-danger': document.pivot.state && document.pivot.state != 'validated'}"
              (click)="showRefusalPopUp()">{{ docRefusalValue ? docRefusalValue : 'Refuser' }}</button>

      <!--    pop up refusal    -->
      <div class="position-absolute bg-white pt-2 px-3 pb-0 br-16 shadow" *ngIf="openRefusalPopUp">
        <p class="font-12">Sélectionnez un motif de refus en cliquant sur un des boutons ou personnalisez-le via le formulaire.</p>
        <p class="fw-bold font-12 mb-1">Pensez à valider dans tous les cas.</p>
        <div class="d-flex align-items-center gap-8">
          <button class="btn btn-danger py-0 px-1 font-12" (click)="docRefusalValue = 'unreadable'" title="Définir le document comme illisible">Illisible</button>
          <button class="btn btn-danger py-0 px-1 font-12" (click)="docRefusalValue = 'incorrect'" title="Définir le document comme incorrect">Incorrect</button>
        </div>
        <div class="d-flex gap-8 align-items-center">
          <mat-form-field class="font-12 mt-1">
            <mat-label>Raison personnalisée</mat-label>
            <input matInput type="text" [(ngModel)]="docRefusalValue">
          </mat-form-field>
          <mat-icon class="bg-primary text-white p-2 d-flex align-items-center justify-content-center pointer br-4" (click)="validate(docRefusalValue)"
                    title="Mettre à jour le statut du document">done</mat-icon>
        </div>
      </div>

    </div>

</div>


<!------------------------------------------------------ reupload ----------------------------------------------------->
<div class="mx-5 reupload_box overflow-hidden transition025 d-flex flex-column" [ngClass]="{'open':openReuploadPart}">
  <div class="d-flex justify-content-between align-items-center pt-3">
    <h6>Reupload de <strong>{{ document.name }}</strong></h6>
    <button type="button" class="lightGray2 btn border-0 p-0" aria-label="Close" (click)="showReupload()">
      <span class="material-icons-outlined font-14">close</span>
    </button>
  </div>
  <app-upload-file class="w-100"
                   [documentType]="document.key" [mode]="'single'" [userId]="user.id"></app-upload-file>
</div>
